<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'app',
    
}
</script>

<style>
    * {
        padding: 0;
        margin: 0;
    }
    #app {
        height: 100vh;
        width: 100vw;
        
    }
    /* 在全局样式文件中 */
    .el-dialog__body {
        padding: 0px !important;
    }
</style>